export default "__VITE_ASSET__08e465cd__"